// Arquivo gerado por scripts/gerar-versao.js. Não editar.
export const versao = {
  "versao": "1.0.4",
  "commit": "76c1940d",
  "dataBuild": "2026-11-04T14:10:18.723Z"
};
